import { render } from "./FormData.vue?vue&type=template&id=5b8cba3c&scoped=true&lang=html"
import script from "./FormData.vue?vue&type=script&lang=js"
export * from "./FormData.vue?vue&type=script&lang=js"

import "./FormData.vue?vue&type=style&index=0&id=5b8cba3c&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8cba3c"]])

export default __exports__